import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

const Modal = ({ children, title, isOpen = false, setIsOpen, message, closeModalTrigger = false }) => {
  function closeModal() {
    setIsOpen(false);
  }

  useEffect(() => {
    if (closeModalTrigger) {
      closeModal();
    }
  }, [closeModal]);

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black/50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-8 text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-between items-center border-b border-gray-100 pb-4">
                    <Dialog.Title as="h3" className="text-xl font-semibold text-gray-900">
                      {title}
                    </Dialog.Title>
                    <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full">
                      <FaTimes />
                    </button>
                  </div>
                  {message && (
                    <div className="mt-4 mb-6">
                      <p className="text-sm text-gray-500">{message}</p>
                    </div>
                  )}
                  <div className="mt-4">{children}</div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default Modal;
